export const caseQueryParamsToParams = (queryParams?: {
  [key: string]: any
}): {
  hazards: { pagination: { pageSize: number; pageIndex: number } }
  actions: { pagination: { pageSize: number; pageIndex: number } }
} => ({
  hazards: {
    pagination: {
      pageSize: queryParams?.hazards?.pagination?.pageSize || 10,
      pageIndex: queryParams?.hazards?.pagination?.pageIndex || 0,
    },
  },
  actions: {
    pagination: {
      pageSize: queryParams?.actions?.pagination?.pageSize || 10,
      pageIndex: queryParams?.actions?.pagination?.pageIndex || 0,
    },
  },
})

export const hazardQueryParamsToParams = (queryParams?: {
  [key: string]: any
}): {
  mitigations: { pagination: { pageSize: number; pageIndex: number } }
} => ({
  mitigations: {
    pagination: {
      pageSize: queryParams?.mitigations?.pagination?.pageSize || 10,
      pageIndex: queryParams?.mitigations?.pagination?.pageIndex || 0,
    },
  },
})
